import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { Reports, CreateReport, UpdateReport } from "./pages";

export const ReportsRouter = [
  <Route
    path="/reports"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Reports />
      </ProtectedRoute>
    }
  />,

  <Route path="/report">
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateReport />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateReport />
        </ProtectedRoute>
      }
    />
  </Route>,
];
